import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth > 992;
    }
    return true;
  });

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebarMobile = () => {
    if (window.innerWidth <= 992) {
      setSidebarOpen(false);
    }
  };

  // Close sidebar on mobile when route changes
  useEffect(() => {
    if (window.innerWidth <= 992) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  // Adjust sidebar state on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        // Desktop default open
        setSidebarOpen(true);
      } else {
        // Mobile default closed
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "var(--slate-50)", overflowX: "hidden" }}>
      <Navbar onToggleSidebar={toggleSidebar} />
      <div style={{ display: "flex", flex: 1, minHeight: "calc(100vh - 64px)", position: "relative" }}>
        <Sidebar isOpen={sidebarOpen} onCloseMobile={closeSidebarMobile} />
        <main
          className="main-content-layout"
          style={{
            flex: 1,
            padding: "24px 28px",
            overflowY: "auto",
            maxWidth: "100%",
            transition: "all 0.2s",
            minWidth: 0,
          }}
        >
          <div style={{ maxWidth: 1400, margin: "0 auto" }}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;

